module.exports = {
      id: "home-banner-eagle-usage",
      viewBox: "0 0 500 250",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#home-banner-eagle-usage",
      toString: function () {
        return this.url;
      }
    }